export default "__VITE_ASSET__YkTel6Mr__"